"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnerArticleApiClient = createPartnerArticleApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createPartnerArticleApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function createArticle(partnerId, article) {
        try {
            const response = await client.post(`/v2/partners/${partnerId}/articles`, article);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function findAllArticlesByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/articles`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function findOneArticleByPartnerIdAndSlug(partnerId, slug) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/articles/${slug}`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    // returns nothing with status_code : 204
    async function updateArticleByPartnerIdAndSlug(partnerId, slug, article) {
        try {
            const response = await client.post(`/v2/partners/${partnerId}/articles/${slug}`, article);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function deleteArticle(partnerId, slug) {
        try {
            const response = await client.delete(`/v2/partners/${partnerId}/articles/${slug}`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function findAnchoredArticleByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/anchored-article`);
            return response.data;
        }
        catch (err) {
            if (err.response.status === 404)
                return null;
            (0, infra_1.handleError)(err);
        }
    }
    return {
        createArticle,
        findAllArticlesByPartnerId,
        findOneArticleByPartnerIdAndSlug,
        updateArticleByPartnerIdAndSlug,
        deleteArticle,
        findAnchoredArticleByPartnerId
    };
}
